import { format } from 'date-fns';
import React from 'react'
import { useEffect } from 'react';
import { useState } from 'react';
import { FaEdit, FaTrash } from 'react-icons/fa';
import { Link } from 'react-router-dom';
import { CircleSpinnerOverlay } from 'react-spinner-overlay';
import { toast } from 'react-toastify';
import { claimTypesOptions, contractStatuses } from '../../assets/data/option';
import { useDMSContext } from '../../context/DMSContext';
import claimService from '../../services/ClaimService';
import MyButton from '../../UI/button/MyButton';
import Card from '../../UI/Card/Card'
import MySelect from '../../UI/select/MySelect';
import GenericTable from '../../UI/table/GenericTable';
import MyTextarea from '../../UI/textarea/MyTextarea';
import WizardForm from '../Forms/WizardForm';
import Overlay from '../Overlay';

export default function ClaimsSection() {
  const { contracts, debtors, claims } = useDMSContext();
  const [debtorId, setDebtorId] = useState(0);
  const [contractId, setContractId] = useState(0);
  const [claimType, setClaimType] = useState("DELAY_NOTIFICATION");
  const [claimValue, setClaimValue] = useState("");
  const [filteredContracts, setFilteredContracts] = useState(contracts);

  const [obligationSource, setObligationSource] = useState("");
  const [obligationType, setObligationType] = useState("");
  const [nonExecutionType, setNonExecutionType] = useState("");
  const [hasPenaltyClause, setHasPenaltyClause] = useState(false);
  const [penaltyPercent, setPenaltyPercent] = useState(null);
  const [paymentNature, setPaymentNature] = useState("");
  const [gracePeriodDays, setGracePeriodDays] = useState(null);

  const [showWizard, setShowWizard] = useState(false);
  const [loading, setLoading] = useState(false);


  const debtorOptions = [
    { value: 0, label: " --Selectează debitorul-- " },
    ...debtors.map(d => ({ value: d.id, label: d.name }))
  ];

  const contractOptions = [
    { value: 0, label: " --Selectează contractul-- " },
    ...filteredContracts.map(c => ({ value: c.id, label: c.name }))
  ];

  const selectedDebtor = debtorOptions.find(opt => opt.value === debtorId);
  const selectedContract = contractOptions.find(opt => opt.value === contractId);
  const selectedClaimType = claimTypesOptions.find(opt => opt.value === claimType);
  const canGoToStepTwo = debtorId != 0 && debtorId != null && claimType != null;

  const deleteClaim = async (claimId) => {

  }

  const handleEditClaim = async (claimData) => {

  }

  const handleGenerateClaimFinal = async (e) => {
    e.preventDefault();
    try {
      setLoading(true);
      const payload = {
        debtorId: debtorId !== 0 ? debtorId : null,
        contractId: contractId !== 0 ? contractId : null,
        type: claimType,
        value: claimValue && claimValue.trim() !== "" ? claimValue : null,
        obligationSource,
        obligationType,
        paymentNature,
        nonExecutionType,
        hasPenaltyClause,
        penaltyPercent: hasPenaltyClause ? penaltyPercent : null,
        gracePeriodDays: hasPenaltyClause ? gracePeriodDays : null,
      };
  
      const result = await claimService.generateClaim(payload);
  
      setClaimValue(result.value);
      setShowWizard(false);
  
      toast.success("Pretenția a fost generată cu succes!");
    } catch (err) {
      console.error("Eroare la generarea pretenției:", err);
      toast.error("A apărut o eroare la generarea pretenției. Încearcă din nou.");
    }finally{
      setLoading(false);
    }
  };

  useEffect(() => {
    if (debtorId && debtorId !== 0) {
      setFilteredContracts(contracts.filter(c => c.debtorId === debtorId)); 
      setContractId(0);
    } else {
      setFilteredContracts([]);
      setContractId(0);
    }
  }, [debtorId, contracts]);

  const settlementColumns = [
    {
      Header: 'DATA',
      accessor: 'creationDate',
      Cell: ({ value }) => {
        try {
          const date = new Date(value);
          return isNaN(date) ? '' : format(date, 'dd.MM.yyyy');
        } catch {
          return '';
        }
      }
    },
    { Header: 'DEBITOR', accessor: 'debtorName',
        enableCellClick: false,
        Cell: ({ row }) => {
          return <Link to={`/dms/debtors/${row.original.debtorId}`}  onClick={(e) => {e.stopPropagation()}}>{row.original.debtorName}</Link>
        }
      },
      { Header: 'CONTRACT', accessor: 'contractName',
      enableCellClick: false,
      Cell: ({ row }) => {
        return <Link to={`/dms/contracts/${row.original.contractId}`}  onClick={(e) => {e.stopPropagation()}}>{row.original.contractName}</Link>
      }
    },
    { Header: 'TIP', accessor: 'type' },
    { Header: 'SUMĂ SOLICITATĂ', accesor: 'requiredAmount' },
    {
      Header: 'STATUS',
      accessor: 'status',
      Cell: ({ value }) => {
        const statusObj = contractStatuses.find(s => s.value == value);
        const label = statusObj ? statusObj.label : value;
        return (<span className={value === 'ACTIVE' ? 'badge-active' : 'badge-inactive'}>
          {label}
        </span>);
      }
    },
    {
        Header: 'ACȚIUNI',
        enableCellClick: false,
        Cell: ({ row }) => (
          <div className="actions">
            <button className="edit" onClick={(e) => {e.stopPropagation();handleEditClaim(row.original)}}>
              <FaEdit />
            </button>
            <button className="delete" onClick={(e) => {e.stopPropagation();deleteClaim(row.original.id)}}>
              <FaTrash />
            </button>
          </div>
        )
      }      
  ];

  return (
    <div className='dms-content'>
      <div className='section-header'><h2>Generare & Istoric Pretenții</h2></div>
      <Card>
        <h3>Generează o Pretenție Nouă</h3>
        <form className='form-container'>
        <div style={{display:"flex", gap:"1rem"}}>
        <div className='myInpWrapper'>
          <label htmlFor={"debtors"} className={'myInpLabel'}>Selectează Debitorul:</label>
          <MySelect 
            options={debtorOptions}
            name="debtors"
            value={selectedDebtor}
            onChange={(selectedOption) => setDebtorId(selectedOption)}
          />
         </div>
         <div className='myInpWrapper'>
          <label htmlFor={"contracts"} className={'myInpLabel'}>Selectează Contractul (opțional):</label>
          <MySelect 
            options={contractOptions}
            name="contracts"
            value={selectedContract}
            onChange={(selectedOption) => setContractId(selectedOption)}
          />
         </div>
        </div>

        <div className='myInpWrapper'>
          <label htmlFor={"debtors"} className={'myInpLabel'}>Tip Pretenție:</label>
          <MySelect 
            options={claimTypesOptions}
            name="debtors"
            value={selectedClaimType}
            onChange={(selectedOption) => setClaimType(selectedOption)}
          />
         </div>

         <div className='myInpWrapper'>
          <label htmlFor={"debtors"} className={'myInpLabel'}>Conținut Pretenție:</label>
          <MyTextarea
                name='claimValue'
                label='claimValue'
                value={claimValue}
                onChange={(e) => setClaimValue(e.target.value)}
              />
          </div>
          <MyButton
            style={{maxWidth:"245px",color:"var(--prolex-blue)",borderColor:"var(--prolex-blue)"}}
            id="generateClaimBtn"
            body="Generează Conținut"
            type="button"
            disabled={!canGoToStepTwo}
            onClick={() => setShowWizard(true)}
          />
        </form>
      </Card>
      <Card>
      <h3 style={{alignSelf:"center",marginBottom:"1rem"}}>Istoric Pretenții Generate</h3>
      <GenericTable data = {claims} columns = {settlementColumns} />
      </Card>
      <Overlay isOpen={showWizard} handleOverlay={() => setShowWizard(!showWizard)} maxWidth="700px">
        <WizardForm
          obligationSource={obligationSource}
          setObligationSource={setObligationSource}
          obligationType={obligationType}
          setObligationType={setObligationType}
          paymentNature={paymentNature}
          setPaymentNature={setPaymentNature}
          nonExecutionType={nonExecutionType}
          setNonExecutionType={setNonExecutionType}
          hasPenaltyClause={hasPenaltyClause}
          setHasPenaltyClause={setHasPenaltyClause}
          penaltyPercent={penaltyPercent}
          setPenaltyPercent={setPenaltyPercent}
          gracePeriodDays={gracePeriodDays}
          setGracePeriodDays={setGracePeriodDays}
          onSubmit={handleGenerateClaimFinal}
          loading={loading}
        />
      </Overlay>
    </div>
  )
}
